<template>
  <el-menu :default-active="menuIndex" :router="true" class="page-menu" mode="horizontal">
    <el-menu-item v-for="(c, i) in menu" :key="i" :index="c.path">{{ c.name }}</el-menu-item>
  </el-menu>
</template>

<script>
export default {
  name: "RadioMenu",
  props: {
    menuIndex: String,
    menu: Array,
  },
  data() {
    return {};
  },
  methods: {},
  watch: {},
  mounted() { },
};
</script>

<style lang="less" scoped>
.page-menu {
  background: none;
  border: 0 none;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  &.el-menu.el-menu--horizontal {
    border-bottom: 0 none;
  }

  /deep/ li.el-menu-item {
    float: none;
    height: 38px;
    line-height: 38px;
    border: 1px solid #2691FF;
    border-color: #2691FF !important;
    color: #2691FF;

    &:hover {
      color: #2691FF;
    }

    &:not(:first-of-type) {
      border-left-width: 0;
    }

    &.is-active {
      background: #2691FF;
      color: #fff;
    }
  }
}
</style>
